import React from "react";
import "./contact.css";
import { IoMdMailUnread } from "react-icons/io";
import { SiMessenger } from "react-icons/si";
import { BsWhatsapp } from "react-icons/bs";
import { useRef } from "react";
import emailjs from "emailjs-com";

const Contact = () => {
  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm(
      "service_ml86a4m",
      "template_t1rj7ss",
      form.current,
      "aDbHg_xWf9GBbm61B")
      e.target.reset()
  };
  return (
    <section id="contact">
      <h5>Get In Touch</h5>
      <h2>Contact Me</h2>
      <div className="container contact__container">
        <div className="contact__options">
          <article className="contact__option">
            <IoMdMailUnread className="contact__option-icon" />
            <h4>Email</h4>
            <h5>ansilyas000@gmail.com</h5>
            <a href="mailto:asnilyas000@gmail.com" target="_blank">
              Send a message
            </a>
          </article>

          <article className="contact__option">
            <SiMessenger className="contact__option-icon" />
            <h4>Messenger</h4>
            <h5>M.AnsIlyas</h5>
            <a href="https://www.facebook.com/profile.php" target="_blank">
              Send a message
            </a>
          </article>

          <article className="contact__option">
            <BsWhatsapp className="contact__option-icon" />
            <h4>WhatsApp</h4>
            <h5>+123456789</h5>
            <a
              href="https://api.whatsapp.com/send?phone=+923213191613"
              target="_blank"
            >
              Send a message
            </a>
          </article>
        </div>

        {/* End of Contact Options  */}
        <form ref={form} onSubmit={sendEmail}>
          <input
            type="text"
            name="name"
            placeholder="Your Full Name"
            required
          />
          <input type="email" name="email" placeholder="Your Email" required />
          <textarea
            name="message"
            rows="7"
            placeholder="your Message"
          ></textarea>
          <button type="submit" className="btn btn-primary">
            Send Message
          </button>
        </form>
      </div>
    </section>
  );
};

export default Contact;
